import React, { useState } from "react";
import { Stack, FormControlLabel, Radio, RadioGroup, Box } from "@mui/material";
import AllArrivalsGrid from "./AllArrivalsGrid";
import RequestDetailsGrid from "./RequestDetailsGrid";
import OutOfRequestServicesGrid from "./OutOfRequestServicesGrid";
import { useTranslate } from "src/locales";
import type { AllVisitsRequestRow, AllRequestRow, RequestDetailRow } from "../types";

export type DateRangeOption = "today" | "10" | "30" | "90";

interface AllArrivalsRequestsTabProps {
  allVisitsRequests?: AllVisitsRequestRow[];
  requestDetails?: RequestDetailRow[];
  outOfRequestServices?: RequestDetailRow[];
  loading?: boolean;
  selectedRowId?: number | string | null;
  onRowSelect?: (row: AllRequestRow) => void;
  onDateRangeChange?: (days: DateRangeOption) => void;
  currentUser?: string;
  ptId?: string | number;
  onVisitsRefresh?: () => void;
  onDetailsRefresh?: () => void;
  detailsLoading?: boolean;
}

export default function AllArrivalsRequestsTab({
  allVisitsRequests = [],
  requestDetails = [],
  outOfRequestServices = [],
  loading = false,
  selectedRowId,
  onRowSelect,
  onDateRangeChange,
  currentUser = "",
  ptId,
  onVisitsRefresh,
  onDetailsRefresh,
  detailsLoading = false,
}: AllArrivalsRequestsTabProps) {
  const { t } = useTranslate();
  const [dateRange, setDateRange] = useState<DateRangeOption>("today");

  const handleDateRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value as DateRangeOption;
    setDateRange(value);
    onDateRangeChange?.(value);
  };

  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      <Box sx={{ my: -1, px: 2 }}>
        <RadioGroup
          row
          value={dateRange}
          onChange={handleDateRangeChange}
          sx={{ gap: 1 }}
        >
          <FormControlLabel
            value="today"
            control={<Radio size="small" />}
            label={t("request-list.date-range.today", "default", { defaultValue: "Bugün" })}
          />
          <FormControlLabel
            value="10"
            control={<Radio size="small" />}
            label={t("request-list.date-range.10-days", "default", { defaultValue: "10 Gün" })}
          />
          <FormControlLabel
            value="30"
            control={<Radio size="small" />}
            label={t("request-list.date-range.30-days", "default", { defaultValue: "30 Gün" })}
          />
          <FormControlLabel
            value="90"
            control={<Radio size="small" />}
            label={t("request-list.date-range.90-days", "default", { defaultValue: "90 Gün" })}
          />
        </RadioGroup>
      </Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      />

      <AllArrivalsGrid
        rows={allVisitsRequests as AllRequestRow[]}
        loading={loading}
        onRowSelect={onRowSelect as any}
      />
      
      <RequestDetailsGrid
        rows={requestDetails}
        loading={loading || detailsLoading}
        title={t("request-list.request-details", "default", {
          defaultValue: "İstek Detayları",
        })}
        currentUser={currentUser}
        ptId={ptId}
        onRefresh={onDetailsRefresh}
      />
      
      <OutOfRequestServicesGrid
        rows={outOfRequestServices}
        loading={loading}
      />
    </Stack>
  );
}
